import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as NoFaceIcon } from "../../../images/noFaceIcon.svg"
import { useSelector } from "react-redux";

const NoFaceModal = () => {
  const isAbsent = useSelector((state) => state.snapshot.isAbsent);
  // const [show, setShow] = useState(false);

  return (
    <>
      <Modal
        show={isAbsent}
        // show={show}
        // onHide={handleClose}
        animation={true}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column align-items-center px-5 py-4 text-center">
            <NoFaceIcon className=""/>
            <h3 className="text-danger px-2">No Face Detected!</h3>
            <h6 className="text-info px-3">Align your face to the webcam to continue with your exam.</h6>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button className="mx-auto calculator-btn" onClick={() => {}}>
            Start Exam
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default NoFaceModal;
